<template>
  <div style="background: white;">
    <div class="main-table" style="height: 100%;width:100%;box-sizing: border-box;padding:0px;overflow: hidden;background:white;">
      <MainTableFilter @filterCond="filterCondChange"/>
      <MainTableTool v-model="selectTab" :dept_tabs="dept_tabs" @searchChange="searchChange" @export="exportClueExcel" @addBussiness="$emit('addBussiness')"/>
      <custom-table
          style="height:calc(100vh - 170px);"
          ref="mytable"
          table-id="clue-table"
          @row-click="rowClick"
          :project-list-dl="tableData.projectList"
          @sort-change="sortChange"

          :show-coloums-dl="tableData.showColoums"
          :column_mapper="tableData.column_mapper"

          :sort-column-name-dl="tableData.sortColumnName"
          :sort-column-order-dl="tableData.sortColumnOrder"

          @current-change="currentChange"
          :totalnums-dl="tableData.totalnums"
          :pagesize-dl="tableData.pagesize"
          :page-number-dl="tableData.pageNumber"

          :fixed-columns="tableData.fixedList"
          :fixed-right-columns="tableData.fixedRightList"

          :disableDrag="true"

          :sortable="false"
          :sortableColumns="tableData.sortableColumns"

          :pagination="tableData.pagination"

          :is-loading-dl="tableData.detailLoading"
          :use-virtual="false"
          :row-hegit="0"

          :tableColumnCustomConfig="tableData.tableColumnCustomConfig"
          :custom-tabel-height-offset="265"
          :padding="'0px'"
          :custom-column-width="tableData.customColumnWidth"
          @editClick="editClick"
      ></custom-table>
      <addBusinessDialog 
        v-model="dialogFormVisible" 
        action="edit" :edit-form="clueInfoDetailFormat" 
        @refresh="refresh"
      ></addBusinessDialog>
    </div>
  </div>
</template>

<script>
import CustomTable from "@/component/CustomTable";
import MainTableTool from "@/component/Business/main/mainTable/MainTableTool";
import MainTableFilter from "@/component/Business/main/mainTable/MainTableFilter";
import addBusinessDialog from "@/component/Business/dialog/addBusinessDialog";
import {exportClue, exportUsageRecord, getAdvance, getClueList} from "@/api/api";

export default {
  name: "MainTable",
  props:["refreshCount"],
  components:{
    CustomTable,
    addBusinessDialog,
    MainTableTool,
    MainTableFilter
  },
  data(){
    return {
      tableData:{
        //表格列表相关
        detailLoading: false,
        projectList: [],//表格列表所有数据
        showProjectList:[],//显示的数据
        column_mapper: {},//表头所有列的枚举
        showColoums: [],//当前显示的表头列
        sortColumnName: "",//需要排序的列名
        sortColumnOrder: "",//排序的命令
        totalnums: 10,//所有的数据条数
        pageNumber: 1,//当前页
        fixedList: ['client_name', 'clue_desc'],
        fixedRightList:['client_manager'],
        sortableColumns:['client_name','create_time','clue_update_time','estimate_amount'],
        pagesize: 10,//一页数据的行数（公用）
        pagination:true,
        cystinFontSize: "16px",
        customColumnWidth:{
          id:80,
          contact: 80,
          contact_info: 80,
          clue_desc:350,
          clue_status:98,
          clue_stage:98,
          client_name:90,
          client_manager:90,
          content:200,
          competitor:90,
          business_type:160,
          quotation_type:160,
          estimate_amount:90,
          pre_sale_principal:100,
          pre_sale_time:120,
          estimate_start_time:90,
          estimate_close_time:90,
          create_time:90,
          clue_update_time:90,
          success_rate:70,
          secondary_dept:120,
          pre_sale:110,
        },
        tableColumnCustomConfig:{//图表某些列定制化显示
          'clue_desc':{
            type:"edit",
          },
          'client_name':{
            type:"colorText",
            colorClass:"t-blue"
          },
          'clue_status':{
            type:"indicator",
            colorMap:{
              "未启动": "#909399",
              "已启动": "#67C23A",
              "已签约": "#409EFF",
              "项目取消": "#E6A23C",
              "已输单": "#F56C6C"
            }
          },
          'business_type':{
            type:"tag",
            tagTypeMap:"info"
          },
          'quotation_type':{
            type:"tag",
            tagTypeMap:"info"
          },
          'success_rate':{
            type:"tag",
            tagTypeMap:{
              "高": "success",
              "中": "warning",
              "低": "info"
            }
          },
          'pre_sale_time':{
            type:"colorText",
            colorClass:"t-gray"
          },
          'create_time':{
            type:"colorText",
            colorClass:"t-gray"
          },
          'update_time':{
            type:"colorText",
            colorClass:"t-gray"
          },
          'secondary_dept':{
            type:"colorText",
            colorClass:"t-gray"
          },
          'pre_sale':{
            type:"tag",
            tagTypeMap:{
              "是": "",
              "否": "info"
            }
          }
        }
      },
      dialogFormVisible:false,
      clueInfoDetailFormat:null,

      selectTab:"全部",
      dept_tabs:[
        {
          label:"我的",
          type:"client_manager",
          hide:true
        },
        {
          label:"全部",
          type:"all"
        },
        {
          label:"应用实施事业部",
          type:"primary_dept"
        },
        {
          label:"产品和运营事业部",
          type:"primary_dept"
        },
        {
          label:"投放组",
          type:"primary_dept"
        },
        {
          label:"道乐人合部",
          type:"primary_dept"
        }
      ],
      searchInput:"",
      filterCond:[],
      filterContent:{
        queryCond: [],
        sortCond: {
          columnName: "",
          value: ""
        },
      },
    }
  },
  mounted() {
    let userDept = this.$store.state.userDept
    // console.log('userDept123',userDept)
    if(['应用实施事业部', '产品和运营事业部', '投放组', '道乐人合事业部'].includes(userDept.p_dept_name)){
      this.dept_tabs[0].hide = false
    }
    this.selectTab = this.dept_tabs.filter(t=>!t.hide)[0].label

    this.queryCondFormatByTab()
  },

  watch:{
    refreshCount(){
      this.refresh()
    },
    selectTab(newVal){
      // console.log('selectTabChange',newVal)
      this.queryCondFormatByTab()
    }
  },

  methods:{
    async exportClueExcel(){
      let param = {
        ...this.filterRequestData
      }
      console.log('exportClueExcel/param',param)
      let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
      try {
        let {data} = await exportClue(param)
        loadingInstance.close();
        const blob = new Blob([data])
        var date = new Date()
        let Y = date.getFullYear().toString()
        let M = (date.getMonth() + 1).toString().padStart(2, "0")
        let D = date.getDate().toString().padStart(2, "0")
        let H = date.getHours().toString().padStart(2, "0")
        let m = date.getMinutes().toString().padStart(2, "0")
        let s = date.getSeconds().toString().padStart(2, "0")
        let fileName = '商机线索-'+this.selectTab+ '-' + Y + M + D + H + m + s + ".xlsx"

        const link = document.createElement('a')
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释
      } catch (err) {
        loadingInstance.close();

        var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        if (issafariBrowser) {
          this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
        } else {
          this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
        }
      }
    },
    filterCondChange(filterCond){
      this.filterCond = filterCond
      this.refresh(true)
    },
    searchChange(e){
      this.searchInput = e
      this.refresh(true)
    },
    queryCondFormatByTab(){
      let tab_info = this.dept_tabs.find(t=>t.label==this.selectTab)
      // console.log('tab_info',tab_info)
      let fKeyIdx = this.filterContent.queryCond.map(q=>q.columnName).indexOf('client_manager')
      if(fKeyIdx!==-1){
        this.filterContent.queryCond.splice(fKeyIdx,1)
      }
      let fKeyIdx2 = this.filterContent.queryCond.map(q=>q.columnName).indexOf('primary_dept')
      if(fKeyIdx2!==-1){
        this.filterContent.queryCond.splice(fKeyIdx2,1)
      }
      if(tab_info.type=='client_manager'){
        this.filterContent.queryCond.push({
          columnName:"client_manager",
          columnValue:this.$cookies.get("username"),
          filter: "eq"
        })
      }else if(tab_info.type=='primary_dept'){
        this.filterContent.queryCond.push({
          columnName:"primary_dept",
          columnValue:tab_info.label,
          filter: "eq"
        })
      }
      this.refresh(true)
    },
    editClick(e){
      this.clueInfoDetailFormat = Object.assign(JSON.parse(JSON.stringify(e)),{clue_id:e.id})
      // console.log('editClickQuick',e,this.clueInfoDetailFormat)
      this.dialogFormVisible = true
      //快捷弹出编辑
    },
    rowClick(e) {
      this.$emit("editClick",e)
    },
    sortChange(e) {
      console.log('sortChange',e)

      if (e.order === null) {
        this.filterContent.sortCond.columnName = ""
        this.filterContent.sortCond.value = ""
      } else {
        this.filterContent.sortCond.columnName  = e.prop
        if (e.order === 'ascending') {
          this.filterContent.sortCond.value = 'asc'
        } else {
          this.filterContent.sortCond.value = 'desc'
        }
      }
      this.refresh()
    },
    async currentChange(e) {
      console.log('currentChange',e)
      this.tableData.pageNumber = e;
      this.refresh(false)
    },
    async refresh(resetPage=true){
      this.tableData.detailLoading = true
      await this.getData(resetPage)
    },
    async getData(resetPage=false){
      if(resetPage){
        // this.tableData.pageNumber = 1
      }

      this.filterRequestData = {
        pagiInfo: {
          currentPage: this.tableData.pageNumber,
          pagesize: this.tableData.pagesize
        },
        searchCond:this.searchInput,
        ...this.filterContent
      }
      this.filterRequestData = JSON.parse(JSON.stringify(this.filterRequestData))
      this.filterRequestData.queryCond.push(...this.filterCond)
      let postData = this.filterRequestData
      // console.log('MainTable/postData', postData)
      let res = await getClueList(postData)
      let resData = res.respData
      const {cols_mapper, data , columns_list,totalnums} = resData
      // console.log('返回结果', resData,cols_mapper,data,columns_list)
      this.tableData.column_mapper = cols_mapper
      this.tableData.projectList = data
      this.tableData.totalnums =  totalnums
      this.tableData.showColoums = columns_list
      // console.log('this.tableData.showColoums',this.tableData.showColoums )


      this.$nextTick(() => {
        this.tableData.detailLoading = false
      })



    },
  }
}
</script>
<style lang="scss">
.main-table {
  .el-table__fixed {
    border-right: solid 0.5px rgba(0, 0, 0, 0.05);
    //right:0.5px;

  }

  .el-table__fixed-right {
    border-left: solid 0.5px rgba(0, 0, 0, 0.05);

  }

  .el-table__fixed::before {
    background-color: transparent;
  }
}
</style>
<style lang="scss" scoped>


.main-table{
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #F5F5F5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */
  border-radius: 3px;
  /* background-color: #F5F5F5; */
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  //background: rgba(165, 174, 193, 0.7);
  //height: 30px;
}
}
</style>
